<div class="toast-wrapper">
  <div *ngFor="let t of toasts" class="toast" [ngClass]="t.type">
    <div class="toast-message">{{ t.message }}</div>
  </div>
</div>
